import React from 'react'
import { connect } from 'react-redux'
import Clients from '../components/clients/clients'

const mapStateToProps = (state) => ({
  ...state.clients
})

const mapDispatchToProps = dispatch => ({
  onPageChange: (payload) => dispatch({type: 'CLIENTS.PAGE_CHANGE', payload: payload}),
  onClientUpdate: (payload) => dispatch({type: 'CLIENTS.CLIENT_UPDATE', payload: payload}),
  onSort: (payload) => dispatch({type: 'CLIENTS.SORT', payload: payload}),
  onSearch: (payload) => dispatch({type: 'CLIENTS.SEARCH', payload: payload}),
  onAddClient: (payload) => dispatch({type: 'CLIENTS.CLIENT_ADD', payload: payload})
})

export default connect(mapStateToProps, mapDispatchToProps)(Clients)
